/*
 * Public API Surface of ng2-simple-global
 */

export * from './lib/ng2-simple-global.service';
